import { Avatar } from '@hivebrite/design-system/Avatar';
import { Box } from '@hivebrite/design-system/Box';
import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';
import { DefaultLink } from '@hivebrite/design-system/Link';

import { type SharedCardProfile } from 'hb-react/frontoffice/apps/Mentoring/types';
import {
  NO_RELATIONSHIP_STATUS,
  RELATIONSHIP_STATUS,
} from 'hb-react/shared/apps/Mentoring/constants';

import StatusIcon from '../StatusIcon';

interface UserPresentationProps {
  profile: SharedCardProfile;
  withStatusLabel?: boolean;
}

const UserPresentation = ({
  profile,
  withStatusLabel = false,
}: UserPresentationProps) => {
  const {
    user_id: userId,
    name,
    photo_thumb_url: photoThumbUrl,
    relationship_with_current_user: relationshipWithCurrentUser,
  } = profile;

  const statusLabel = !relationshipWithCurrentUser
    ? NO_RELATIONSHIP_STATUS
    : RELATIONSHIP_STATUS[relationshipWithCurrentUser.status];

  const statusText = withStatusLabel
    ? `${s__('Mentoring|Status')}: ${statusLabel}`
    : statusLabel;

  return (
    <Box minHeight="60px" mb="9px">
      <Box position="relative" minWidth="60px">
        <DefaultLink
          href={Routes.user_path(userId)}
          styledOnlyOnHover
          font="h4-semibold"
          aria-label={__('Go to user %{name} profile').i__({ name })}
        >
          <Avatar src={photoThumbUrl} size={60} alt="" />
          <StatusIcon status={relationshipWithCurrentUser?.status} />
        </DefaultLink>
      </Box>
      <Box flexDirection="column" ml={3} mt="10px" flex="1">
        <Box mb={1}>
          <DefaultLink
            href={Routes.user_path(userId)}
            styledOnlyOnHover
            font="h4-semibold"
          >
            <Dotdotdot clamp={1}>{name}</Dotdotdot>
          </DefaultLink>
        </Box>
        <Box mb={3} font="metadata-regular-asphalt">
          {statusText}
        </Box>
      </Box>
    </Box>
  );
};

export default UserPresentation;
